import { RestServiceConnection } from "../RestServiceConnection";


export class TherapeuticAreaService extends RestServiceConnection {
    
    search = async (filter: any) => {
        this.response = await this.makeRequest({
            method: "post",
            url: '/therapeutic_area/search',
            data: filter
        }, true);
        return this;
    }

}